import Vue from "vue"

export const FloatingCardsEventBus = new Vue()
export const MapViewEventBus = new Vue()
export const ProcessingsTilesEventBus = new Vue()
export const PostProcessingsTilesEventBus = new Vue()
